export default __webpack_public_path__ + "static/media/stamp_6.8813cc68.png";